// import React, { useRef } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Box, SxProps, Typography } from '@mui/material';
import { Editor } from "@ckeditor/ckeditor5-core";
import { UploadAdapter, FileLoader } from "@ckeditor/ckeditor5-upload/src/filerepository";
import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import './text-editor.css'
import { getToken } from '../../utils/app.utils';

import {
	DecoupledEditor,
	AccessibilityHelp,
	Alignment,
	Autoformat,
	AutoImage,
	AutoLink,
	Autosave,
	BalloonToolbar,
	BlockQuote,
	Bold,
	CloudServices,
	Code,
	Essentials,
	FindAndReplace,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	Heading,
	Highlight,
	HorizontalLine,
	ImageBlock,
	ImageCaption,
	ImageInline,
	ImageInsertViaUrl,
	ImageResize,
	ImageStyle,
	ImageTextAlternative,
	ImageToolbar,
	ImageUpload,
	Indent,
	IndentBlock,
	Italic,
	Link,
	LinkImage,
	List,
	ListProperties,
	Markdown,
	MediaEmbed,
	PageBreak,
	Paragraph,
	PasteFromMarkdownExperimental,
	PasteFromOffice,
	RemoveFormat,
	SelectAll,
	SpecialCharacters,
	SpecialCharactersArrows,
	SpecialCharactersCurrency,
	SpecialCharactersEssentials,
	SpecialCharactersLatin,
	SpecialCharactersMathematical,
	SpecialCharactersText,
	Strikethrough,
	Subscript,
	Superscript,
	Table,
	TableCaption,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar,
	TextTransformation,
	TodoList,
	Underline,
	Undo
} from 'ckeditor5';


import 'ckeditor5/ckeditor5.css';

import '../../App.css';
type Props = {
	textString: string;
	onChange: (text: string) => void;
	sx?: SxProps;
	height?: string;
	disabled?: boolean;
	heading?: string;
}
function uploadAdapter(loader: FileLoader): UploadAdapter {
	const token = getToken();
	return {
		upload: () => {
			return new Promise(async (resolve, reject) => {
				try {
					const file = await loader.file;
					const response = await axios.request({
						method: "POST",
						url: `${process.env.REACT_APP_BASE_API}/media/upload-file-media-public`,
						data: {
							files: file
						},
						headers: {
							'Authorization': `Bearer ${token}`,
							"Content-Type": "multipart/form-data"
						}
					});
					console.log(response, 'response')
					resolve({
						default: `${process.env.REACT_APP_FILE_BASE_API}/${response?.data?.data[0]?.media_file_path}${response?.data?.data[0]?.media_file_name}`
					});
				} catch (error) {
					reject("Not have api to call");
				}
			});
		},
		abort: () => { }
	};
}
function uploadPlugin(editor: Editor) {
	editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
		return uploadAdapter(loader);
	};
}
const TextEditorCustom: React.FC<Props> = (props: Props) => {
	const { textString, onChange, sx, height, disabled } = props;
	const editorContainerRef = useRef<any>(null);
	const editorMenuBarRef = useRef<any>(null);
	const editorToolbarRef = useRef<any>(null);
	const editorRef = useRef<any>(null);
	const [isLayoutReady, setIsLayoutReady] = useState(false);

	useEffect(() => {
		setIsLayoutReady(true);

		return () => setIsLayoutReady(false);
	}, []);

	const editorConfig: any = {
		toolbar: {
			items: [
				'undo',
				'redo',
				'|',
				'findAndReplace',
				'selectAll',
				'|',
				'heading',
				'|',
				'fontSize',
				'uploadImage',
				'fontFamily',
				'fontColor',
				'fontBackgroundColor',
				'|',
				'bold',
				'italic',
				'underline',
				'strikethrough',
				'subscript',
				'superscript',
				'code',
				'removeFormat',
				'|',
				'specialCharacters',
				'horizontalLine',
				'pageBreak',
				'link',
				'mediaEmbed',
				'insertTable',
				'highlight',
				'blockQuote',
				'|',
				'alignment',
				'|',
				'bulletedList',
				'numberedList',
				'todoList',
				'outdent',
				'indent',
				'|',
				'accessibilityHelp'
			],
			shouldNotGroupWhenFull: true
		},
		extraPlugins: [uploadPlugin],
		plugins: [
			AccessibilityHelp,
			Alignment,
			Autoformat,
			AutoImage,
			AutoLink,
			Autosave,
			BalloonToolbar,
			BlockQuote,
			Bold,
			CloudServices,
			Code,
			Essentials,
			FindAndReplace,
			FontBackgroundColor,
			FontColor,
			FontFamily,
			FontSize,
			Heading,
			Highlight,
			HorizontalLine,
			ImageBlock,
			ImageCaption,
			ImageInline,
			ImageInsertViaUrl,
			ImageResize,
			ImageStyle,
			ImageTextAlternative,
			ImageToolbar,
			ImageUpload,
			Indent,
			IndentBlock,
			Italic,
			Link,
			LinkImage,
			List,
			ListProperties,
			// Markdown,
			MediaEmbed,
			PageBreak,
			Paragraph,
			PasteFromMarkdownExperimental,
			PasteFromOffice,
			RemoveFormat,
			SelectAll,
			SpecialCharacters,
			SpecialCharactersArrows,
			SpecialCharactersCurrency,
			SpecialCharactersEssentials,
			SpecialCharactersLatin,
			SpecialCharactersMathematical,
			SpecialCharactersText,
			Strikethrough,
			Subscript,
			Superscript,
			Table,
			TableCaption,
			TableCellProperties,
			TableColumnResize,
			TableProperties,
			TableToolbar,
			TextTransformation,
			TodoList,
			Underline,
			Undo
		],
		balloonToolbar: ['bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList'],
		fontFamily: {
			supportAllValues: true
		},
		fontSize: {
			options: [10, 12, 14, 'default', 18, 20, 22],
			supportAllValues: true
		},
		heading: {
			options: [
				{
					model: 'paragraph',
					title: 'Paragraph',
					class: 'ck-heading_paragraph'
				},
				{
					model: 'heading1',
					view: 'h1',
					title: 'Heading 1',
					class: 'ck-heading_heading1'
				},
				{
					model: 'heading2',
					view: 'h2',
					title: 'Heading 2',
					class: 'ck-heading_heading2'
				},
				{
					model: 'heading3',
					view: 'h3',
					title: 'Heading 3',
					class: 'ck-heading_heading3'
				},
				{
					model: 'heading4',
					view: 'h4',
					title: 'Heading 4',
					class: 'ck-heading_heading4'
				},
				{
					model: 'heading5',
					view: 'h5',
					title: 'Heading 5',
					class: 'ck-heading_heading5'
				},
				{
					model: 'heading6',
					view: 'h6',
					title: 'Heading 6',
					class: 'ck-heading_heading6'
				}
			]
		},
		image: {
			toolbar: [
				'toggleImageCaption',
				'imageTextAlternative',
				'|',
				'imageStyle:inline',
				'imageStyle:wrapText',
				'imageStyle:breakText',
				'|',
				'resizeImage'
			]
		},
		initialData: '',
		// '<h2>Congratulations on setting up CKEditor 5! 🎉</h2>\n<p>\n    You\'ve successfully created a CKEditor 5 project. This powerful text editor will enhance your application, enabling rich text editing\n    capabilities that are customizable and easy to use.\n</p>\n<h3>What\'s next?</h3>\n<ol>\n    <li>\n        <strong>Integrate into your app</strong>: time to bring the editing into your application. Take the code you created and add to your\n        application.\n    </li>\n    <li>\n        <strong>Explore features:</strong> Experiment with different plugins and toolbar options to discover what works best for your needs.\n    </li>\n    <li>\n        <strong>Customize your editor:</strong> Tailor the editor\'s configuration to match your application\'s style and requirements. Or even\n        write your plugin!\n    </li>\n</ol>\n<p>\n    Keep experimenting, and don\'t hesitate to push the boundaries of what you can achieve with CKEditor 5. Your feedback is invaluable to us\n    as we strive to improve and evolve. Happy editing!\n</p>\n<h3>Helpful resources</h3>\n<ul>\n    <li>📝 <a href="https://orders.ckeditor.com/trial/premium-features">Trial sign up</a>,</li>\n    <li>📕 <a href="https://ckeditor.com/docs/ckeditor5/latest/installation/index.html">Documentation</a>,</li>\n    <li>⭐️ <a href="https://github.com/ckeditor/ckeditor5">GitHub</a> (star us if you can!),</li>\n    <li>🏠 <a href="https://ckeditor.com">CKEditor Homepage</a>,</li>\n    <li>🧑‍💻 <a href="https://ckeditor.com/ckeditor-5/demo/">CKEditor 5 Demos</a>,</li>\n</ul>\n<h3>Need help?</h3>\n<p>\n    See this text, but the editor is not starting up? Check the browser\'s console for clues and guidance. It may be related to an incorrect\n    license key if you use premium features or another feature-related requirement. If you cannot make it work, file a GitHub issue, and we\n    will help as soon as possible!\n</p>\n',
		language: 'th',
		link: {
			addTargetToExternalLinks: true,
			defaultProtocol: 'https://',
			decorators: {
				toggleDownloadable: {
					mode: 'manual',
					label: 'Downloadable',
					attributes: {
						download: 'file'
					}
				}
			}
		},
		list: {
			properties: {
				styles: true,
				startIndex: true,
				reversed: true
			}
		},
		placeholder: 'Type or paste your content here!',
		table: {
			contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
		},
	};

	return (
		<div className='w-full'>
			{props.heading && (
				<Typography variant='h5' my={1}>
					{props.heading}
				</Typography>
			)}
			<div className="main-container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="editor-container editor-container_document-editor" ref={editorContainerRef}>
					<div className="editor-container__toolbar" ref={editorToolbarRef}></div>
					<div className="editor-container__editor-wrapper">
						<div className="editor-container__editor">
							<div ref={editorRef}>
								{isLayoutReady && (
									<CKEditor
										onReady={editor => {
											editorToolbarRef.current.appendChild(editor.ui.view.toolbar.element);
										}}
										onAfterDestroy={() => {
											Array.from(editorToolbarRef.current.children).forEach((child: any) => child.remove());
										}}
										disabled={disabled}
										editor={DecoupledEditor}
										config={editorConfig}
										data={textString}
										onChange={(event, editor) => {
											const data = editor.getData();
											onChange(data);
										}}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		// <Box sx={sx} className='w-full h-full border-2 p-4 rounded-[8px]'>
		//     <CKEditor
		//         disabled={disabled}
		//         editor={ClassicEditor}
		//         data={textString}
		//         onChange={(event, editor) => {
		//             const data = editor.getData();
		//             onChange(data);
		//         }}
		//         onReady={(editor: any) => {
		//             editor.editing.view.change((writer: any) => {
		//                 writer.setStyle(
		//                     "min-height",
		//                     height || "180px",
		//                     editor.editing.view.document.getRoot()
		//                 );
		//             });
		//         }}
		//         config={{
		//             extraPlugins: [uploadPlugin],
		//             toolbar: {
		//                 items: [
		//                     'heading', '|',
		//                     'bold', 'italic',
		//                     // 'underline',
		//                     // 'strikethrough',
		//                     // 'subscript',
		//                     // 'superscript', '|',
		//                     'link',
		//                     'bulletedList',
		//                     'numberedList',
		//                     // 'todoList',
		//                     '|',
		//                     'blockQuote',
		//                     'insertTable',
		//                     // 'imageUpload',
		//                     'mediaEmbed',
		//                     '|',
		//                     // 'alignment',
		//                     // 'indent',
		//                     // 'outdent', '|',
		//                     // 'fontSize',
		//                     // 'fontFamily',
		//                     // 'fontColor',
		//                     // 'fontBackgroundColor', '|',
		//                     // 'highlight',
		//                     // 'horizontalLine',
		//                     // 'pageBreak',
		//                     '|',
		//                     'undo', 'redo'
		//                 ],
		//                 shouldNotGroupWhenFull: false,
		//             },
		//             initialData: textString,
		//         }}
		//     />
		// </Box>
	)
}

export default TextEditorCustom;